'use strict';

const formValidation = require('base/components/formValidation');
const clientSideValidation = require('../../components/clientSideValidation');
const $document = $(document);
const $newsletterFormInOverlay = $('.newsletter-form-overlay');

const newsletterSubmit = function () {
    $document.on('submit', '.newsletter-form', function (e) {
        e.preventDefault();
        const $form = $(this);
        const url = $form.attr('action');
        $form.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                } else {
                    $form.closest('.newsletter-component-wrapper').addClass('form-success');
                    $form.removeClass('d-block');
                    $('body').trigger('gtm:add:event', data);
                }
            },
            error: function () {
                $form.spinner().stop();
            },
        });
        return false;
    });
};

$document.ready(function () {
    // to show legal text and subscribe CTA on email field click for CHL
    $document.on('click', '#newsletter-form-email', function () {
        const $newsletterWrapper = $(this).closest('.newsletter-component-wrapper');
        $newsletterWrapper.find('.newsletter-legal-text').show();
        $newsletterWrapper.find('.subscribe-newsletter-btn').addClass('show');
    });

    // to show newsletter form on the click of (page designer signup button)
    $document.on('click', '.signup-newsletter-btn', function (e) {
        e.preventDefault();
        let $this = $(this);
        $this.closest('.newsletter-component-wrapper').find('.newsletter-form').addClass('d-block');
        if (!$this.hasClass('slider-opener')) {
            $this.hide();
        }
    });

    // for the newsletter form submit
    if (!window.recaptchaSiteKey) {
        newsletterSubmit();
    }

    $document.on('click', '#newsletter-form .subscribe-newsletter-btn', function () {
        const $this = $(this);
        const $thisForm = $this.closest('form');
        clientSideValidation.functions.validateForm($thisForm.get(0));
    });

    $document.on('click', '.signup-newsletter-btn', function () {
        if ($newsletterFormInOverlay.length) {
            var $newsletterForm = $('.newsletter-form-overlay form');
            $newsletterForm[0].reset();
            $newsletterForm.find('.is-invalid, .has-error, .valid').removeClass('is-invalid has-error valid');
            $newsletterForm.find('#newsletter-form-title-overlay').val('').trigger('change');
            $('.newsletter-component-wrapper').removeClass('form-success');
        }
    });
});

module.exports = {
    newsletterSubmit: newsletterSubmit,
};
